<div class="wizard-menu">
    <button type="button" class="step-item" *ngFor="let step of steps; let i = index" [class.active]="currentStep === i + 1"
        [class.completed]="currentStep > i + 1" [class.visited]="currentStep >= i + 1"
        [style.min-height.px]="step.minHeight ?? 70" [attr.aria-current]="currentStep === i + 1 ? 'step' : null"
        (click)="toggleStep(i)">
        <span class="step-indicator">
            <span *ngIf="currentStep <= i + 1">{{ i + 1 }}</span>
            <span *ngIf="currentStep > i + 1" class="check-icon">
                <img src="assets/images/tick.svg" alt="">
            </span>
        </span>
        <span class="step-details">
            <strong class="step-title">{{ step.title }}</strong>
            <span class="step-description">{{ step.description }}</span>
        </span>
    </button>
</div>